<template>
    <Form :model="formData" :label-width="100"  :rules="formRules" ref="formData">
        <FormItem label="供应商名称" prop="supplierName">
            <Input v-model="formData.supplierName" class="item-width" ></Input>
        </FormItem>

        <FormItem label="品牌" prop="brand">
            <Input v-model="formData.brand" class="item-width"></Input>
        </FormItem>
        <FormItem label="供应类目" prop="categoryName">
            <Select v-model="formData.categoryName" multiple :label-in-value="true" placeholder="点击选择类目" @on-change="getCategories"  class="item-width">
                <Option v-for="item in categoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="负责人" prop="manager">
            <Input v-model="formData.manager" class="item-width" ></Input>
        </FormItem>
        <FormItem label="联系方式" prop="contactPhone">
            <Input v-model="formData.contactPhone" class="item-width"></Input>
        </FormItem>
    </Form>
</template>
 
<script type="text/ecmascript-6">
export default {
    props: {
      n:{
        type:Number,
        default:0
      },
    categoryList:{
        type:Array,
        default:null
    }
    },
    watch: {
      n(){
        this.$refs['formData'].resetFields();
        this.formData.supplierName=""
        this.formData.brand=""
        this.formData.categoryName=[]
        this.formData.manager=""
        this.formData.contactPhone=""
      } 

    },
    data () {
        const validatecontactPhone = (rule, value, callback) => {
          let pattern = /^1\d{10}$/
          if(!pattern.test(value)){
            callback(new Error('输入正确的联系方式'));
          }
          callback();
        }
        return {
          categories:[],
          formData:{
              supplierName:'',
              brand:'',
              categoryName:[],
              manager:'',
              contactPhone:''
          },
          formRules:{
              supplierName:[
                { required: true, message: '请输入供应商名称' ,trigger: 'blur', type:'string'}
              ],
              brand:[
                  {required:true, message: '请输入品牌名称', trigger: 'blur',type:'string'}   
              ],
              categoryName:[
                  { required: true,type: 'array', min: 1, message: '请选择类目', trigger: 'change' }
              ],
              manager:[
                  { required: true,message: '请输入负责人' ,trigger: 'blur', type:'string'}
              ],
              contactPhone:[
                {required:true, validator: validatecontactPhone, trigger: 'blur'}
              ]
          }
        }
    },
    methods: {
        formValidate() {
            let obj = {
              supplierName:'',
              brand:'',
              categoryName:'',
              manager:'',
              contactPhone:''  
            };
            this.$refs['formData'].validate( bool => {    
                if(bool){
                   obj.supplierName = this.formData.supplierName
                   obj.brand = this.formData.brand
                   obj.categoryName = this.categories
                   obj.manager = this.formData.manager
                   obj.contactPhone = this.formData.contactPhone     
                }else{
                    obj = false
                }
            })
            return obj
        },
        getCategories(val){
            let categories = ''
            if(val.length!==0){
              val.forEach((item,i,val) => {
                categories += (i !== val.length-1 ? item.label +',' : item.label)
              })  
            }
            this.categories = categories    
        }
    }
}
</script>
 
<style lang="css" scoped>
.item-width{
    width: 200px;
}
.area-width{
    width: 324px;
}
</style>